module.exports = __webpack_public_path__ + "img/ring_r_i_null_1@3x.933a4b96.png";